module.exports = __webpack_public_path__ + "static/media/12UNCTAD6.1bbd3ad7.jpg";